import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type SaAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatSaToastLabel(code: string | undefined): string {
    const t = typeof code === "string" ? code.trim() : "";
    return t.length > 0 ? t : EntityLabels.sourceActivity;
}

export function getSaAdminActionSuccessMessage(
    kind: SaAdminConfirmKind,
    code: string | undefined
): string {
    const label = formatSaToastLabel(code);
    const successByKind: Record<SaAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

type SaRow = { id: string; code: string };

export const buildSaAdminPagedListActions = (openConfirm: (kind: SaAdminConfirmKind, item: SaRow) => void) =>
    buildRecordLifecyclePagedListActions<SaRow>(openConfirm, { activeMember: "isActive" });
